class PublicCmsSplitTest {
    constructor(splitTestData, regex) {
        this.regex = regex;
        this.execute = () => {
            var runawayLimit = 10 * 1000; //10s
            var ellapsedTime = 0;
            var interval = 50;
            var scriptIndex = 0;
            var exec = () => {
                try {
                    var match = this.regex.exec(this.variant.javascript[scriptIndex]);
                    if (match == null || match.length < 2) {
                        var js = this.variant.javascript.splice(scriptIndex).join("\n");
                        $(() => {
                            this.execScript(js);
                        });
                        return;
                    }
                    else {
                        if ($(match[1].substr(1, match[1].length - 2)).length) {
                            if (!this.execScript(this.variant.javascript[scriptIndex])) {
                                return;
                            }
                            else {
                                scriptIndex++;
                                if (scriptIndex === this.variant.javascript.length) {
                                    return;
                                }
                            }
                        }
                    }
                    ellapsedTime += interval;
                    if (ellapsedTime > runawayLimit) {
                        this.log('runaway on ' + this.variant.javascript[scriptIndex]);
                        return;
                    }
                    setTimeout(exec, interval);
                }
                catch (err) {
                    this.log(err);
                }
            };
            //force async
            setTimeout(exec, 1);
        };
        this.id = splitTestData.id;
        try {
            var variantIndex = splitTestData.selectedVariantIndex;
            var search = window.location.search;
            var qsKey = "cmsSplitTestPreview" + splitTestData.id + '=';
            if (search.indexOf(qsKey) != -1) {
                variantIndex = parseInt(search.split(qsKey)[1].split('&')[0]);
                splitTestData.skipTracking = true;
            }
            if (splitTestData.experimentId != null && !splitTestData.skipTracking) {
                if (typeof cxApi == 'undefined') {
                    this.log("cxApi not found");
                    return;
                }
                ;
                cxApi.setChosenVariation(variantIndex, splitTestData.experimentId);
            }
            if (variantIndex == null)
                variantIndex = 0;
            this.variant = splitTestData.variants[variantIndex];
            if (typeof this.variant == 'undefined') {
                this.log("Could not find variant at index " + variantIndex + " for experimentid " + splitTestData.experimentId);
                return;
            }
        }
        catch (err) {
            this.log(err);
            return;
        }
        if (typeof splitTestData.activationJavascript != 'undefined' && splitTestData.activationJavascript != null && splitTestData.activationJavascript != "") {
            this.execScript(splitTestData.activationJavascript, { name: "splitTest", value: this });
        }
        else {
            this.execute();
        }
    }
    execScript(script, ...params) {
        try {
            var headerScript = "";
            var footerScript = "";
            if (typeof params != 'undefined' && params != null && params.length > 0) {
                headerScript = "(function(";
                footerScript = "})(";
                for (var i = 0; i < params.length; i++) {
                    headerScript += params[i].name + (i < params.length - 1 ? ", " : "");
                    footerScript += "params[" + i + "].value" + (i < params.length - 1 ? ", " : "");
                }
                headerScript += "){ ";
                footerScript += ");";
            }
            eval(headerScript + script + footerScript);
            return true;
        }
        catch (err) {
            this.log(err);
            return false;
        }
    }
    log(message, ...params) {
        if (console && console.log) {
            if (console.trace)
                console.trace();
            console.log(message, params);
        }
    }
}
class CmsPublic {
    constructor(doc) {
        this.isInsectingOnLoad = false;
        this.addSplitTest = (splitTest) => {
            if (!this.isInsectingOnLoad) {
                if ($.grep(this.splitTests, (st) => st.id == splitTest.id).length == 0) {
                    this.splitTests.push(new PublicCmsSplitTest(splitTest, this.regex));
                }
            }
        };
        this.document = doc;
        this.splitTests = [];
        this.regex = new RegExp("^\\$j?\\(([\'\"].+?[\'\"]|document)\\)\\..+;(?:\\s|(?:\\\/\\\/.*|\\\/\\*(?:[^*]|\\*(?!\\\/))*\\*\\\/))*$");
    }
}
(function (w) {
    var cmsPublic = new CmsPublic(window.document);
    w["cmsPublic"] = cmsPublic;
})(window);
//# sourceMappingURL=cms_public.js.map